var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":("tel:" + _vm.phoneNumberFromMsisdn)}},[_vm._v(" "+_vm._s(_vm._f("regexGroups")(_vm.phoneNumberFromMsisdn,/(\d\d\d)(\d\d\d)(\d+)/))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }